// extracted by mini-css-extract-plugin
module.exports = {"container":"_inputswitch_container__-Ga1c","input":"_inputswitch_input__27YZZ"};